"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRTextPosition = void 0;
const QRTextPosition = exports.QRTextPosition = {
  Top: 'top',
  Bottom: 'bottom',
  Blank: 'blank'
};
